import { Auth } from "aws-amplify";
import AWS from "aws-sdk";

const getLambdaClient = async () => {
    const credentials = await Auth.currentCredentials(); // Get credentials from Amplify
    AWS.config.update({
        region: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION,
        credentials: credentials,
    });

    return new AWS.Lambda();
};

const S3_Util = {
    async callLambda(folderName) {
        if (!folderName) {
            throw new Error("Folder name is required.");
        }

        const lambda = await getLambdaClient();

        const params = {
            FunctionName: process.env.REACT_APP_S3_LAMBDA_FUNCTION, // Replace with your Lambda function's name
            InvocationType: "RequestResponse", // Synchronous invocation
            Payload: JSON.stringify({ folderName }),
        };

        try {
            const response = await lambda.invoke(params).promise();
            const payload = JSON.parse(response.Payload);

            if (response.FunctionError) {
                throw new Error(`Lambda error: ${payload.errorMessage}`);
            }

            console.log("Lambda response:", payload);
            return payload;
        } catch (error) {
            console.error("Error invoking Lambda:", error);
            throw error;
        }
    },

    async getS3File(key) {
        try {
            // Get current user's AWS credentials from Amplify
            const credentials = await Auth.currentCredentials();

            // Configure AWS SDK with those credentials
            AWS.config.update({
                region: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION,
                credentials: Auth.essentialCredentials(credentials),
            });

            const s3 = new AWS.S3();

            // Get the object from S3
            const params = {
                Bucket: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET,
                Key: key,
            };

            const result = await s3.getObject(params).promise();

            // result.Body will be a Buffer
            const fileContent = result.Body.toString("utf-8");

            const jsonResult = JSON.parse(fileContent).results;
            return jsonResult;
        } catch (error) {
            console.error("Error getting file from S3:", error);
            return [];
        }
    }
};

export default S3_Util;
